import {useContext} from 'react';

import {AvatarDropDownMenu} from '../AvatarDropDownMenu/AvatarDropDownMenu';

import {AppHeaderWrapper} from './Components/AppHeaderWrapper';
import {ApplicantAppHeader} from './Components/ApplicantAppHeader/ApplicantAppHeader';
import {B2BHeader} from './Components/B2BHeader/B2BHeader';
import {CompanyAppHeader} from './Components/CompanyAppHeader/CompanyAppHeader';
import {PublicAppHeader} from './Components/PublicAppHeader/PublicAppHeader';
import {UserContext} from '../../contexts/UserContext/UserContext';

type HeaderType = 'applicant' | 'b2b' | 'company' | 'public';

interface Props {
  type: HeaderType;
}

const HeaderComponent = {
  applicant: ApplicantAppHeader,
  b2b: B2BHeader,
  company: CompanyAppHeader,
  public: PublicAppHeader,
};

export const AppHeader = ({type}: Props) => {
  const {isLoading} = useContext(UserContext);

  const Header = HeaderComponent[type];

  return (
    <>
      {isLoading && (
        <AppHeaderWrapper isTransparent={type === 'public'}>
          <AvatarDropDownMenu />
        </AppHeaderWrapper>
      )}
      {!isLoading && <Header />}
    </>
  );
};
